class ComparisonTable {
    constructor(filter, table) {
        this.filter = filter;
        this.rowsToHide = [];
        this.blocksToHide = [];
        this.toggleAllBlocksTrigger = this.filter.querySelector(".js-comparison-toggle-all");

        this.table = table;
        this.blocks = [];
        this.blocksData = [];
        this.rowsData = [];
        this.neededHeight = 0;

        this._init();
    }

    _init() {
        const promise = new Promise((resolve) => {
            this._prepareBlocks();
            this._initCellsHeightAligner();

            setTimeout(() => resolve(), 0);
        });

        promise.then(() => {
            this._analyzeRowsForFilter();
            this._initFilter();
        });

        this._initBlocksToggler();

        if (!window.mobileMedia) {
            this._initAllBlocksToggler();
        }
    }

    _prepareBlocks() {
        this.blocks = Array.from(this.table.querySelectorAll(".js-comparison-table-block"));

        this.blocks.forEach((block) => {
            const rowsData = this._prepareRows(block);

            this.blocksData.push({
                target: block,
                data: rowsData,
            });

            this.rowsData.push(...rowsData);
        });
    }

    _prepareRows(block) {
        const rowHeaders = Array.from(block.querySelectorAll(".js-comparison-table-block-header"));
        const blockSlides = Array.from(block.querySelectorAll(".swiper-slide"));

        return rowHeaders.map((header, i) => {
            const cells = blockSlides.map((slide) => slide.querySelectorAll(".js-comparison-table-block-cell")[i]);
            const cellsData = [header, ...cells];

            return { elements: cellsData };
        });
    }

    _initCellsHeightAligner() {
        this.rowsData.forEach((row) => {
            const cellsData = row.elements;

            setTimeout(() => {
                if (!window.mobileMedia) {
                    this._setHeightPC(cellsData);
                } else {
                    this._setHeightMobile(cellsData);
                }
            }, 0);
        });
    }

    _setHeightPC(cellsData) {
        this.neededHeight = Math.max(...cellsData.map((cell) => cell.offsetHeight));

        cellsData.forEach((cell) => {
            if (cell.offsetHeight !== this.neededHeight) {
                cell.style.height = `${this.neededHeight}px`;
            }
        });

        this.neededHeight = 0;
    }

    _setHeightMobile(cellsData) {
        const [header, ...cells] = cellsData;
        const maxCellHeight = Math.max(...cells.map((cell) => parseFloat(getComputedStyle(cell).height)));
        const headerHeight = getComputedStyle(header).height;

        header.style.setProperty("--cell-content-base-height", `${maxCellHeight}px`);

        cells.forEach((cell) => {
            cell.style.setProperty("--header-content-base-height", `${headerHeight}`);
            cell.style.setProperty("--cell-content-base-height", `${maxCellHeight}px`);
        });
    }

    _analyzeRowsForFilter() {
        for (let blockIndex = 0; blockIndex < this.blocksData.length; blockIndex++) {
            const block = this.blocksData[blockIndex].data;

            for (let rowIndex = 0; rowIndex < block.length; rowIndex++) {
                const row = block[rowIndex].elements;
                const characteristics = [];

                for (let cellIndex = 1; cellIndex < row.length; cellIndex++) {
                    const cell = row[cellIndex];

                    characteristics.push(cell.innerHTML.toLowerCase().replace(/\s+/g, ""));
                }

                if (this._isSameCharacteristics(characteristics)) {
                    block[rowIndex].hidden = true;
                }
            }

            if (block.every((row) => row.hidden)) {
                this.blocksToHide.push(this.blocksData[blockIndex].target);
            } else {
                block.forEach((row) => {
                    if (row.hidden) this.rowsToHide.push(row.elements);
                });
            }
        }
    }

    _isSameCharacteristics(characteristics) {
        return characteristics.every((characteristic) => characteristic === characteristics[0]);
    }

    _initFilter() {
        this.filterButtons = this.filter.querySelectorAll(".js-comparison-filter-trigger");
        if (!this.filterButtons) return;

        for (const filterButton of this.filterButtons) {
            const filterType = filterButton.getAttribute("data-compare");
            filterButton.onchange = () => {
                this._toggleRows(filterType);
            };

            if (filterButton.checked) {
                this._toggleRows(filterType);
            }
        }
    }

    _toggleRows(filterParameter) {
        switch (filterParameter) {
            case "DIFF":
                this._hideDifferences();
                break;

            case "ALL":
                this._unhideDifferences();
                break;
        }
    }

    _hideDifferences() {
        this.blocksToHide.forEach((block) => {
            block.classList.add("hidden");
        });

        this.rowsToHide.forEach((row) => {
            row.forEach((cell) => {
                cell.classList.add("hidden");
            });
        });
    }

    _unhideDifferences() {
        this.blocksToHide.forEach((block) => {
            block.classList.remove("hidden");
        });

        this.rowsToHide.forEach((row) => {
            row.forEach((cell) => {
                cell.classList.remove("hidden");
            });
        });
    }

    _initAllBlocksToggler() {
        if (!this.toggleAllBlocksTrigger) return;

        const toggleClass = "active";

        this.toggleAllBlocksTrigger.addEventListener("click", () => {
            const isButtonActive = this.toggleAllBlocksTrigger.classList.contains(toggleClass);

            if (isButtonActive) {
                for (const block of this.blocks) {
                    block.classList.remove(toggleClass);
                }
            } else {
                for (const block of this.blocks) {
                    block.classList.add(toggleClass);
                }
            }

            this.toggleAllBlocksTrigger.classList.toggle(toggleClass);
        });
    }

    _initBlocksToggler() {
        for (const block of this.blocks) {
            block.addEventListener("click", (e) => {
                if (e.target.classList.contains("js-comparison-block-title")) {
                    block.classList.toggle("active");
                    this._checkActiveBlocks();
                }
            });
        }
    }

    _checkActiveBlocks() {
        if (this.blocks.every((block) => block.classList.contains("active"))) {
            this.toggleAllBlocksTrigger.classList.add("active");
        } else {
            this.toggleAllBlocksTrigger.classList.remove("active");
        }
    }
}

const comparisonFilter = document.querySelector(".js-comparison-filter-init");
const comparisonTable = document.querySelector(".js-comparison-table");

if (comparisonFilter && comparisonTable) {
    window.addEventListener("load", () => new ComparisonTable(comparisonFilter, comparisonTable));
}
